
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"58","height":"58","viewBox":"0 0 58 58","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"fill":"#686871","fill-rule":"nonzero","width":"58","height":"58","rx":"12"}}),_c('path',{attrs:{"d":"M39.5 30.75h-8.75v8.75c0 1.288-.462 2.333-1.75 2.333s-1.75-1.045-1.75-2.333v-8.75H18.5c-1.29 0-2.333-.46-2.333-1.75 0-1.288 1.044-1.75 2.333-1.75h8.75V18.5c0-1.288.462-2.333 1.75-2.333s1.75 1.045 1.75 2.333v8.75h8.75c1.288 0 2.333.462 2.333 1.75 0 1.29-1.045 1.75-2.333 1.75","fill":"#FFF"}})])]);
        };
      

        module.exports = {
          
          render: render,
        };
      